// import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import React from "react";
import BallotIcon from "@mui/icons-material/Ballot";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import ToggleTabs from "../../../../../../components/ToggleTabs";

const TOGGLE_TABS: { value: "list" | "calender"; icon: React.ReactNode }[] = [
  { value: "list", icon: <BallotIcon sx={{ fontSize: 16 }} /> },
  { value: "calender", icon: <CalendarMonthIcon sx={{ fontSize: 16 }} /> },
];

const ToggleTaskCalenderViewButton = ({
  view,
  handleAlignment,
}: {
  view: "list" | "calender";
  handleAlignment: (
    event: React.MouseEvent<HTMLElement>,
    newAlignment: "list" | "calender" | null
  ) => void;
}) => {
  return (
    <ToggleTabs
      tabs={TOGGLE_TABS}
      activeTab={view}
      onTabChange={(newView) => {
        handleAlignment({} as React.MouseEvent<HTMLElement>, newView);
      }}
      containerSx={{
        border: "none",
        borderBottom: "none",
        p: 0,
        backgroundColor: "transparent",
      }}
    />
  );
};

export default ToggleTaskCalenderViewButton;
